import type { ReactNode } from "react";

const sizes = {
  xs: { tile: "h-6 w-6 rounded-lg", icon: "h-4 w-4" },
  sm: { tile: "h-8 w-8 rounded-lg", icon: "h-4 w-4" },
  md: { tile: "h-10 w-10 rounded-xl", icon: "h-5 w-5" },
  lg: { tile: "h-11 w-11 rounded-xl", icon: "h-6 w-6" },
} as const;

export type GradientIconTileSize = keyof typeof sizes;

export function GradientIconTile({ children, tone, size = "md", muted = false, className = "" }: {
  children: ReactNode;
  tone: string;
  size?: GradientIconTileSize;
  muted?: boolean;
  className?: string;
}) {
  return (
    <span aria-hidden="true" className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden bg-gradient-to-br text-white shadow-md ${sizes[size].tile} ${muted ? "from-slate-400 to-slate-600" : tone} ${className}`}>
      <span className="absolute inset-x-1.5 top-0 h-px bg-white/60" />
      <span className={sizes[size].icon}>{children}</span>
    </span>
  );
}
